import { useQuery } from 'react-query';

import { QueryResponse, getReportAccessStatus as queryFn } from 'api/endPoints/GetReportAccessStatus';
import { QueryKeys } from 'api/queryKeys';

export const useQueryGetReportAccess = (params: QueryParams) => {
    return useQuery<QueryResponse, QueryError, QueryResponse, [QueryKeys, unknown]>({
        queryKey: ['getReportAccessStatus', params],
        queryFn: () => queryFn(params),
        enabled: Boolean(params.id),
        cacheTime: 0,
    });
};

interface QueryParams {
    id: number;
}
